import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { sponsorshipKeys } from "./keys";
import { paymentKeys } from "../payments/keys";
import {
  createSponsorship,
  deleteSponsorship,
  getAllSponsorships,
  updateSponsorship,
  recordSponsorshipPayment,
} from "./api";
import { toast } from "sonner";

export const useSponsorships = (options = {}) => {
  return useQuery({
    queryKey: sponsorshipKeys.list(),
    queryFn: getAllSponsorships,
    staleTime: 2 * 60 * 1000, // 2 min — avoids redundant refetches
    ...options,
  });
};

export const useCreateSponsorship = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSponsorship,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sponsorshipKeys.list() });
      toast.success("Sponsorship created successfully");
    },
    onError: (error) => {
      toast.error(
        error.response?.data?.message || "Failed to create sponsorship",
      );
    },
  });
};

export const useUpdateSponsorship = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSponsorship,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sponsorshipKeys.list() });
      toast.success("Sponsorship updated successfully");
    },
    onError: (error) => {
      toast.error(
        error.response?.data?.message || "Failed to update sponsorship",
      );
    },
  });
};

export const useDeleteSponsorship = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSponsorship,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sponsorshipKeys.list() });
      toast.success("Sponsorship deleted successfully");
    },
    onError: (error) => {
      toast.error(
        error.response?.data?.message || "Failed to delete sponsorship",
      );
    },
  });
};

export const useRecordSponsorshipPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: recordSponsorshipPayment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sponsorshipKeys.list() });
      queryClient.invalidateQueries({ queryKey: paymentKeys.lists() });
      toast.success("Payment recorded successfully");
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Failed to record payment");
    },
  });
};
